import { render, staticRenderFns } from "./one.vue?vue&type=template&id=1671403d&"
import script from "./one.vue?vue&type=script&lang=js&"
export * from "./one.vue?vue&type=script&lang=js&"
import style0 from "./one.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports